<template id="child">
  <div v-if="showModal" :style="cssProps">
    <div  class="modal d-flex flex-column justify-content-center" style="overflow-y: scroll; -webkit-overflow-scrolling: touch;">
        <h1>Add a New Delivery Address</h1>
        <div class="column-input d-flex flex-column justify-content-around">
            <div class="d-flex flex-column">
                <input type="text" placeholder="Enter full name" v-model="deliveryInfo.fullname" name="fullname">
                <span class="not-work">{{ errors.first('fullname') }}</span>
            </div>
            <div class="house d-flex flex-row justify-content-around">
                <div class="d-flex flex-column">
                    <input type="text" placeholder="Address" v-model="deliveryInfo.streetaddress" name="streetaddress" v-validate="'required'">
                    <span class="not-work">{{ errors.first('streetaddress') }}</span>
                </div>
                <div class="d-flex flex-column">
                    <input type="text" placeholder="Building" v-model="deliveryInfo.building" name="building" v-validate="'required'">
                    <span class="not-work">{{ errors.first('building') }}</span>
                </div>
            </div>
            <div class="d-flex flex-column">
                <input type="text" placeholder="Additional Information" v-model="deliveryInfo.specialinstructions" name="specialinstructions">
                <span class="not-work">{{ errors.first('specialinstructions') }}</span>
            </div>

            <div class="row-input d-flex flex-row justify-content-around">
                <div class="d-flex flex-column">
                    <input type="text" placeholder="City" v-model="deliveryInfo.city" name="city" v-validate="'required'">
                    <span class="not-work">{{ errors.first('city') }}</span>
                </div>
                <div class="d-flex flex-column">
                    <input type="text" placeholder="State" v-model="state" name="state" v-validate="'required'">
                    <span class="not-work">{{ errors.first('state') }}</span>
                </div>
                <div class="d-flex flex-column">
                    <input type="text" placeholder="Zip Code" v-model="deliveryInfo.zipcode" name="zipcode" v-validate="'required|numeric|min:5|max:6'">
                    <span class="not-work">{{ errors.first('zipcode') }}</span>
                </div>
            </div>
            <div class="d-flex flex-column phone-input">
                <input type="text" placeholder="Phone Number" v-model="deliveryInfo.phonenumber" name="phonenumber" v-validate="'required|numeric|min:11|max:11'">
                <span class="not-work">{{ errors.first('phonenumber') }}</span>
            </div>
        </div> 
          <div class="button d-flex flex-row justify-content-between">
                <button @click="hide">
                    <span>Cancel</span>
                </button>
                <button @click="submit">
                    <span>Add</span>
                </button>
            </div>
    </div>
    <div class="modal-overlay"></div>
  </div>  
</template>
<script>
import { mapState } from "vuex";
export default {
    template: '#child',
    $_veeValidate: {
        validator: 'new', 
    },
    data(){
        return{
            showModal: false,
            state: null,
            deliveryInfo:{
                id: 0,
                fullname: null,
                building: null,
                streetaddress: null,
                city: null,
                zipcode: null,
                phonenumber: null,
                specialinstructions: null,
                isdefault: false
            }
        }
    },
    computed: {
        ...mapState(['info']),
		cssProps() { return {
                '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
            }
        }
	},
    methods: {
        show() {
            this.showModal = true;
        },
        hide(){
            this.showModal = false;
        },
        async submit(){
            //validate form
            const checking = await this.$validator.validateAll();
            console.log(checking)
            if(checking){
                this.$emit('submit', this.deliveryInfo);
                this.deliveryInfo = { id: 0, building: null, address: null, specialinstructions: null, city: null, state: null, zipcode: null, phonenumber: null};
                this.state = null;
                this.showModal = false;
            }
        }
    },
    created(){
        //load from vuex
    }
}
</script>
<style scoped>
.not-work{
    
	height: 24px;
width: 240px;
border-radius: 4px;
/* background-color:var(--main-color); */
color: var(--main-color);
font-family: Poppins;
font-size: 10px;
font-weight: 400;
line-height: 16px;
word-spacing:1.2px;
position: relative;
top: 10px;
text-align: center;

}
.house 
{
    width: 100%;
}
.house div:first-child input, span
{
    width:216px !important;
    
}
.house div:last-child input, span
{
    width: 110px !important;
}
button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.button
{
    width: 100%;
}

.button button:first-child 
{
  

	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;

}
.button button:first-child span{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
.button button:last-child
{
	height: 48px;
	width: 160px;
	border-radius: 24px;
	background-color: var(--main-color);
}
.button button:last-child span{
    
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;

}
input
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.column-input
{
    width: 100%;
    height: 100%;
   
}
.column-input input
{
    border: none;
	width: 336px;
	height: 56px;
	background-color: #FFFFFF;
	/* box-shadow: 0 1px 0 0 rgba(0,0,0,0.2); */
    padding: 18px;
    border-bottom: 1px solid rgba(0,0,0,0.2)
}
.column-input input::placeholder
{
	opacity: 0.3 !important;
	color: #000000;
	font-family: Poppins;
	font-size: 13px !important;
	font-weight: 500;
	line-height: 20px;
}
.row-input
{
    width: 100%;
}
.row-input input{
    width: 100px;
}
.phone-input span{
    width: 100% !important;
}
.modal {
   position: fixed;;
  left:250px;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 48px;
  box-sizing: border-box;
	
    z-index: 10;
   
	height: 586px;
	width: 434px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
}
.modal h1{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px !important;
	font-weight: bold;
	line-height: 25px;
	text-align: center;

}


.modal-overlay
{
   position: fixed; 
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 6; 
}
.active
{
    border: 1px solid rgba(0,0,0,0.6) !important;
}
.active span:first-child
{
    font-weight: bold !important;
    color: #000000 !important;
    opacity: 1 ;
}
.active span:last-child
{
    font-weight: 600 !important;
    color: #000000 !important;
    opacity: 1;
}
@media screen and (max-width: 600px) {
    .modal{
        width: 100%;
        padding: 22px;
        left:0;
        bottom: -150px;
        z-index: 13;
    }
    .modal-overlay
    {
        z-index: 12;
    }
    .button
    {
        height: 40%;
        justify-content: center !important;
        flex-direction: column-reverse !important;
        align-items: center !important;
        margin-bottom:35px;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 20px; 
    }
    .button button:last-child
    {
        width: 100%;
    }

}
</style>




// WEBPACK FOOTER //
// src/components/steps/modals/addressModal.vue